import { render, staticRenderFns } from "./ItsLogisticRequest.vue?vue&type=template&id=1a3b1c86&scoped=true&"
import script from "./ItsLogisticRequest.vue?vue&type=script&lang=js&"
export * from "./ItsLogisticRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3b1c86",
  null
  
)

export default component.exports